<script setup lang="ts">
import { type PropType, ref, watch } from 'vue'
import { ObjectAliases, type ObjectsListItemMap, ObjectTypesMap } from '@/entities/Object'
import { WCabinetControlPanel, WCabinetMeterPanel, WCabinetScheduleItem } from '@/widgets'
import WObjectMapInfoHeader from './WObjectMapInfoHeader.vue'
import { useMapCabinet } from './../model/model'
import {
  getElParamsStatuses,
  getMainStatuses,
  getMeterStatuses,
  getPinStatuses,
} from '@/entities/Cabinet'
import { useSseConnection } from '@/shared/lib'
import { debounce } from 'lodash'

const props = defineProps({
  item: {
    type: Object as PropType<ObjectsListItemMap>,
    required: true,
  },
})

const { cabinet, loadCabinet } = useMapCabinet(props.item.id)
const { refetch } = loadCabinet()

const tab = ref<string>('meters')

/* Устанавливаем SSE соединение */
const { handler } = useSseConnection(debounce(refetch, 1000))

watch(
  () => props.item?.id,
  () => handler(`/cabinets/${props.item?.id}/statuses`),
  { immediate: true },
)
</script>

<template>
  <VExpansionPanel density="compact" :min-width="300" :max-width="500">
    <template #title>
      <WObjectMapInfoHeader
        v-if="cabinet"
        :item="cabinet"
        :type="ObjectTypesMap[ObjectAliases.CABINETS]"
        :statuses="[
          ...getMainStatuses(cabinet),
          ...getPinStatuses(cabinet),
          ...getMeterStatuses(cabinet),
          ...getElParamsStatuses(cabinet),
        ]"
      />
    </template>

    <template #text v-if="cabinet">
      <div class="w-object-map-info-item__id">Ид.: {{ item.id }}</div>

      <WCabinetControlPanel
        :object-id="item.id"
        :class="{ status_disabled: cabinet.status === 0 }"
      />

      <VTabs class="mt-4" v-model="tab">
        <VTab value="meters">{{ $t('itf.meters') }}</VTab>
        <VTab value="schedule">{{ $t('itf.schedule') }}</VTab>
      </VTabs>

      <VTabsWindow v-model="tab">
        <VTabsWindowItem value="meters">
          <WCabinetMeterPanel
            class="mt-4"
            v-for="meter in cabinet.meters || []"
            :meter-id="meter.id"
            :object-id="cabinet.id"
          />
        </VTabsWindowItem>

        <VTabsWindowItem value="schedule">
          <WCabinetScheduleItem
            class="mt-4"
            v-if="cabinet.list_schedules_id"
            :schedule-id="cabinet.list_schedules_id"
            :object-id="cabinet.id"
            :schedule-sync="cabinet.main_statuses.is_schedule_synced"
          />

          <div class="mt-4" v-else>{{ $t('itf.not_schedule') }}</div>
        </VTabsWindowItem>
      </VTabsWindow>
    </template>
  </VExpansionPanel>
</template>
